import { LOAD_CAPABILITIES } from "./action_types"

export const load = () => ({
    type: LOAD_CAPABILITIES,
})
